import React from "react";
import "../assets/css/navbar.css";
import { NavLink } from "react-router-dom";

export const Navbar = () => {
  return (
    <header id="header" className="header d-flex align-items-center sticky-top">
      <div className="container-fluid container-xl position-relative d-flex align-items-center">
        <p className="logo d-flex align-items-center me-auto">
          {/* <img src="assets/img/logo.png" alt="" /> */}
          <h1 className="sitename">Peduli TBC</h1>
        </p>

        <nav id="navmenu" className="navmenu">
          <ul>
            <li>
              <NavLink to="/" activeClassName="active">
                Beranda
              </NavLink>
            </li>
            <li>
              <NavLink to="/kebijakan-privasi" activeClassName="active">
                Kebijakan Privasi
              </NavLink>
            </li>
          </ul>
          <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
        </nav>

        <a className="btn-getstarted" href="/">
          Masuk
        </a>
      </div>
    </header>
  );
};
